<template>
  <base-row v-if="fullWidth">
    <div>
      <slot name="default" />
    </div>
  </base-row>
  <two-column-block
    v-else
    :with-separator="false"
  >
    <template #default>
      <slot name="default" />
    </template>
  </two-column-block>
</template>

<script>
import BaseRow from '@/shared/legacy/ui/layout/row.vue';
import TwoColumnBlock from '@/shared/legacy/ui/layout/two-column-block.vue';

export default {
  name: 'LayoutOneColumnBlock',
  components: {
    BaseRow,
    TwoColumnBlock
  },
  props: {
    fullWidth: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<i18n lang="json">{}</i18n>
